import { Fragment } from 'react';
import H5TopBar from '../H5TopBar';
import CardTypeA from './CardTypeA';
import CardTypeB from './CardTypeB';
import CardTypeC from './CardTypeC';

enum CardTypesEnum {
    /** 产品系列四级类目样式 */
    Product = 1,
    /** 场景样式 */
    Scene = 2,
    /** 服务支持样式 */
    Service = 3,
    /** 文字平铺样式 */
    Text = 4,
}

interface Props {
    itemId?: string;
    title: string;
    prefixCls: string;
    item: any;
}

const SubClientList: React.FC<Props> = ({ prefixCls, title, itemId, item }) => {
    return (
        <Fragment key={itemId}>
            <H5TopBar prefixCls={prefixCls} title={title} />
            {[CardTypesEnum.Product].includes(item.type) && <CardTypeA prefixCls={prefixCls} item={item} />}
            {[CardTypesEnum.Scene, CardTypesEnum.Service].includes(item.type) && <CardTypeB prefixCls={prefixCls} item={item} />}
            {[CardTypesEnum.Text].includes(item.type) && <CardTypeC prefixCls={prefixCls} item={item} />}
        </Fragment>
    );
};
export default SubClientList;
